import React, {useState} from 'react';
import Grid from "@mui/material/Grid2";
import CustomMarkdown from "../../components/customMarkdown/CustomMarkdown";
import Container from "@mui/material/Container";
import {StyledMuiCard} from "../../checkout/components/billingData/UserInfo";
import CardActionArea from "@mui/material/CardActionArea";
import {CardContent, Typography} from "@mui/material";
import {Trans} from "react-i18next";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import IronIcon from '@mui/icons-material/Iron';

const views = {
    IRONING: 'ironing',
    WASHING: 'washing'
}

function Tutorials() {
    const [selectedView, setSelectedView] = useState(views.IRONING);

    const handleViewChange = (value) => {
        setSelectedView(value);
    };

    return (
        <Container maxWidth="md">
            <FormControl component="fieldset" fullWidth>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: {xs: 'column', sm: 'row'},
                        gap: 2,
                    }}
                >

                    <StyledMuiCard selected={selectedView === views.IRONING}>
                        <CardActionArea
                            onClick={() => handleViewChange(views.IRONING)}
                            sx={{
                                '.MuiCardActionArea-focusHighlight': {
                                    backgroundColor: 'transparent',
                                },
                                '&:focus-visible': {
                                    backgroundColor: 'action.hover',
                                },
                            }}
                        >
                            <CardContent sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                <IronIcon
                                    fontSize="small"
                                    sx={[
                                        (theme) => ({
                                            color: 'grey.400',
                                            ...theme.applyStyles('dark', {
                                                color: 'grey.600',
                                            }),
                                        }),
                                        selectedView === views.IRONING && {
                                            color: 'primary.main',
                                        },
                                    ]}
                                />
                                <Typography sx={{fontWeight: 'medium'}}><Trans
                                    i18nKey={`tutorial.labels.${views.IRONING}`}/></Typography>
                            </CardContent>
                        </CardActionArea>
                    </StyledMuiCard>
                    <StyledMuiCard selected={selectedView === views.WASHING}>
                        <CardActionArea
                            onClick={() => handleViewChange(views.WASHING)}
                            sx={{
                                '.MuiCardActionArea-focusHighlight': {
                                    backgroundColor: 'transparent',
                                },
                                '&:focus-visible': {
                                    backgroundColor: 'action.hover',
                                },
                            }}
                        >
                            <CardContent sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                <LocalLaundryServiceIcon
                                    fontSize="small"
                                    sx={[
                                        (theme) => ({
                                            color: 'grey.400',
                                            ...theme.applyStyles('dark', {
                                                color: 'grey.600',
                                            }),
                                        }),
                                        selectedView === views.WASHING && {
                                            color: 'primary.main',
                                        },
                                    ]}
                                />
                                <Typography sx={{fontWeight: 'medium'}}><Trans
                                    i18nKey={`tutorial.labels.${views.WASHING}`}/></Typography>
                            </CardContent>
                        </CardActionArea>
                    </StyledMuiCard>
                </Box>
            </FormControl>


            <Grid container size={12} sx={{pt: 3}}>
                <Grid>
                    <CustomMarkdown children={[`tutorial.${selectedView}`]}/>
                </Grid>
            </Grid>
        </Container>
    );
}

export default Tutorials;
